import { render, staticRenderFns } from "./DevStatus2BasicInfo.vue?vue&type=template&id=f9e3996c&scoped=true"
import script from "./DevStatus2BasicInfo.vue?vue&type=script&lang=js"
export * from "./DevStatus2BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./DevStatus2BasicInfo.vue?vue&type=style&index=0&id=f9e3996c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e3996c",
  null
  
)

export default component.exports